import { localizeNumber } from "../../../../helpers";
import ibsStore from "../../../Stores/IbsSurveyStore"
import store from "../../../Stores/SurveyStore"
import { NumberFormat, Tooltips } from "../../../../Enums/constants";
import { calculationsForProvided, columnCalculation } from "../../../../Helpers/TableCalculationHelper";
import { getSurveyResponseValue } from "../../../../Helpers/General/SurveyResponsesHelper";
import { formatNumber } from "../../../../Helpers/General/FormatHelper";

export function handleExpensesData(props, referenceToTable, listOfHeaderRows, dataObj) {
    const numSupportFte = getSurveyResponseValue("NumSupportFTE", null);
    const enhancedInternalId = parseInt(ibsStore.currentSurvey?.EnhancedInternalID ?? 0);

    let includeTotalRow;
    if (ibsStore.isEnhanced || numSupportFte > 14) {
        includeTotalRow = true; //hmm what to do about this
    }

    if (ibsStore.allTableResponses) { //check if data available
        var rawData = ibsStore.allTableResponses[props.tableName]
        if (rawData == [] || typeof rawData === "undefined" || rawData === undefined) return {};
        let referenceToTable = rawData
        rawData = calculationsForProvided(rawData, props);
        let dataObj = rawData.slice();

        //the total row
        let totalRow = {};
        totalRow['NonInvestmentFTE'] = formatNumber(NumberFormat.DECIMAL1, columnCalculation("NonInvestmentFTE", true, props));
        totalRow['SupportActivityID'] = formatNumber(NumberFormat.DECIMAL1, columnCalculation("SupportActivityID", true, props));
        totalRow['SupportCosts'] = formatNumber(NumberFormat.DECIMAL1, columnCalculation("SupportCosts", true, props));
        totalRow['SupportNumFTE'] = formatNumber(NumberFormat.DECIMAL1, columnCalculation("SupportNumFTE", true, props));
        totalRow['del'] = "";
        totalRow['SupportActivityName'] = "Total";
        totalRow['RowID'] = "Total";
        totalRow['DisplayOrder'] = 9999999;
        totalRow['Inactive'] = false;
        totalRow['__children'] = null;

        if (Object.keys(totalRow).length > 0) {
            dataObj.push(totalRow);
            listOfHeaderRows.push(dataObj.length - 1);
        }

        dataObj.forEach((elem) => {
            if (elem.hasOwnProperty('SupportNumFTE')) {
                elem.SupportNumFTE = localizeNumber(elem.SupportNumFTE);
            }
            if (elem.hasOwnProperty('SupportCosts')) {
                elem.SupportCosts = localizeNumber(elem.SupportCosts);
            }

        });

        return [dataObj, referenceToTable, listOfHeaderRows]
    }


}

export function loadExpensesTableErrors() {
    let listOfErrorWarning = [];

    if (store.allValidationErrorsList[store.currentLandedPage]) {
        store.allValidationErrorsList[store.currentLandedPage].forEach(error => {
            if (error.QuestionName == "CExecAdmin") {
                listOfErrorWarning.push({
                    "qName": "SupportCosts",
                    "rowID": 1,
                    "errorTypeID": error.ErrorTypeID,
                    "errorMessage": error.ErrorMessage,
                    "errorExplanation": error.ErrorExplanation,
                    "errorTotalCol": error.totalErrorColumn,
                    "errorId": error.ErrorId
                })
                listOfErrorWarning.push({
                    "qName": "SupportCosts",
                    "rowID": 2,
                    "errorTypeID": error.ErrorTypeID,
                    "errorMessage": error.ErrorMessage,
                    "errorExplanation": error.ErrorExplanation,
                    "errorTotalCol": error.totalErrorColumn,
                    "errorId": error.ErrorId
                })
            } if (error.QuestionName == "CCustTot") {
                listOfErrorWarning.push({
                    "qName": "SupportCosts",
                    "rowID": 7,
                    "errorTypeID": error.ErrorTypeID,
                    "errorMessage": error.ErrorMessage,
                    "errorExplanation": error.ErrorExplanation,
                    "errorTotalCol": error.totalErrorColumn,
                    "errorId": error.ErrorId
                })
            } else {
                listOfErrorWarning.push({
                    "qName": error.QuestionName,
                    "rowID": error.RowID,
                    "errorTypeID": error.ErrorTypeID,
                    "errorMessage": error.ErrorMessage,
                    "errorExplanation": error.ErrorExplanation,
                    "errorTotalCol": error.totalErrorColumn,
                    "errorId": error.ErrorId
                })
            }
        });

    }
    return listOfErrorWarning
}


export function expensesCellRenderer(instance, td, row, col, prop, value, cellProperties, referenceToTable, props, listOfHeaderRows) {
    const rowData = referenceToTable[row];
    if (rowData) {
        if (rowData.SupportActivityID && col === 0) {
            td.className = td.className + " tooltipCustom"
            let span = document.createElement("span")
            span.className = "genericTooltip tooltiptext"
            span.innerHTML = Tooltips[props.tableName][rowData.SupportActivityID]
            td.appendChild(span);
            td.innerHTML += "<sup>ⓘ</sup>"
        }
        if (rowData.SupportActivityID === 7 || rowData.SupportActivityID == 21) {
            // if custodial fees row
            const propName = instance.colToProp(col);
            if (propName === "SupportNumFTE") {
                td.className = td.className + " readOnlyCell"
                cellProperties.readOnly = true;
            }
        }
    }
    return cellProperties

}

export function getHiddenExpensesColumns() {
    let hideCols = []
    const actualValue = getSurveyResponseValue("NumSupportFTE", null);
    const fundSize = getSurveyResponseValue("FundSize", null);
    if (ibsStore.currentSurvey && !ibsStore.isEnhanced
        && actualValue > 14 && fundSize > 5) {
        hideCols.push(1)
    }
    return hideCols
}
